export default __webpack_public_path__ + "static/sticker-3-cf3be871c8964bb58f1ae72bf2a95623.png";